export default function configSearchPage() {
	require.ensure(['utils/setupSearch'], () => {
		const setupSearch = require('utils/setupSearch');

		setupSearch.default();
	});
}



/** WEBPACK FOOTER **
 ** ./Scripts/libs/configPage/search.js
 **/